import React, { useEffect, useState } from 'react';
import { getAssetPlaybackUrl, isUploadConfigured } from '../data/uploadService';

// Renders an uploaded (private-bucket) image via a presigned GET URL.
// Presigned URLs expire, so resolve lazily and cache per session.
const urlCache = new Map(); // s3Key -> { url, ts }
const URL_TTL_MS = 45 * 60 * 1000;

export function useAssetUrl(s3Key) {
  const [url, setUrl] = useState(() => {
    const hit = urlCache.get(s3Key);
    return hit && Date.now() - hit.ts < URL_TTL_MS ? hit.url : null;
  });

  useEffect(() => {
    let alive = true;
    if (!s3Key || url || !isUploadConfigured()) return undefined;
    getAssetPlaybackUrl(s3Key)
      .then((u) => {
        urlCache.set(s3Key, { url: u, ts: Date.now() });
        if (alive) setUrl(u);
      })
      .catch(() => {});
    return () => { alive = false; };
  }, [s3Key, url]);

  return url;
}

export default function AssetImage({ s3Key, alt = '', className = '', onClick }) {
  const url = useAssetUrl(s3Key);
  if (!url) {
    return (
      <div className={`ah-tile-placeholder ${className}`} onClick={onClick}>
        🖼
      </div>
    );
  }
  return <img src={url} alt={alt} className={className} loading="lazy" onClick={onClick} />;
}
